export default "__VITE_ASSET__CxX0QOos__"